import { StatsTheme } from '../types'
import { base } from './base'

import bgGradient from '../assets/bg/stats-theme-bg-pink.webp'
import upsell from '../assets/upsell/fable-plus-upsell-charts-pink.webp'
import { theme } from '@fable/theme'

export const pink: StatsTheme = {
  id: 'pink',
  name: 'Pink',
  colors: {
    base,
    menuDot: base.bubblegum,
    primary: base.bubblegum,
    secondary: base.flamingo,
    bg: '#BE9FB5',
    bgGradient,
    hero: {
      iconColor: base.bubblegum,
      shareTextColor: base.bubblegum,
    },
    section: {
      bg: theme.colors.uiPearlExtraLight,
      bgSecondary: theme.colors.uiWhite,
      text: theme.colors.uiGraphite,
      textSecondary: theme.colors.uiBlack40,
      textReadingGoal: theme.colors.uiBlack40,
      tabBg: '#0706070D',
      tabBtnBg: theme.colors.uiWhite,
      tabBtnText: {
        idle: theme.colors.uiGraphite,
        active: theme.colors.uiGraphite,
      },
      shareBg: theme.colors.uiWhite70,
      shareText: theme.colors.uiGraphite,
      chart: { ghost: theme.colors.uiWhite50, lines: theme.colors.uiBlack10 },
      legend: { text: theme.colors.uiBlack40 },
    },
    goals: {
      petalEmpty: '#EBE12228E2',
    },
    charts: {
      genresPie: ['#DF81C4', '#F8CBE666', '#C7C4C0', '#DFDCD7', '#F197CD'],
      genreStream: ['#F8CBE6', '#FC7676', '#F197CD', '#006FEA', '#E882AA'],
      streakMap: {
        default: theme.colors.uiBlack10,
        bestStreak: '#FC7676',
        daysRead: '#F197CD',
        finished: '#006FEA',
      },
      momStreaks: {
        cellBg: theme.colors.uiWhite70,
        bestStreak: {
          bg: base.bubblegum,
          text: theme.colors.uiPearlExtraLight,
        },
        daysRead: { bg: theme.colors.uiBlack10, text: theme.colors.uiBlack40 },
        noReading: {
          current: {
            bg: 'transparent',
            text: theme.colors.uiBlack40,
            border: 'transparent',
          },
          other: {
            bg: 'transparent',
            text: theme.colors.uiBlack40,
            border: theme.colors.uiWhite70,
          },
        },
      },
    },
    blurs: {
      hero: {
        top: 'rgba(250, 97, 19, 1)',
        middle: 'rgba(255, 195, 210, 1)',
        bottom: 'rgba(250, 97, 19, 1)',
      },
      section: {
        top: 'rgba(252, 118, 118, 0.3)',
        middle: 'rgba(252, 249, 245, 0.8)',
        bottom: 'rgba(252, 249, 245, 0.8)',
        topAlt: 'rgba(252, 249, 245, 0.5)',
        bg: {
          start: 'rgba(244, 164, 169, 1)',
        },
      },
      sectionAlt: {
        top: 'rgba(0, 111, 234, 0.5)',
        middle: 'rgba(252, 249, 245, 0.8)',
        bottom: 'rgba(0, 111, 234, 0.5)',
        topAlt: 'rgba(252, 249, 245, 0.8)',
        bg: {
          start: 'rgba(241, 151, 205, 1)',
        },
      },
    },
    upsell,
    upsellBtnBg: theme.colors.uiWhite,
    upsellBtnText: theme.colors.uiGraphite,
  },
}
